import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { mapWarehouseWithStore } from "../../../services/warehouse/WarehouseWithStore";
import { addWarehouseWithUser } from "../../../services/warehouse/WarehouseWithUser";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  createWarehouseProcessStage,
  putWarehouseProcessStage,
} from "../../../services/WarehouseStage/WarehouseStage";

const WarehouseProcessStageCreateModal = ({
  warehouseStageModalVisible,
  setWarehouseStageModalVisible,
  sendDataToWarehouseStageModal,
  warehouseId,
  selectedItemValue,
}) => {
  const [modalText, setModalText] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [statusError, setStatusError] = useState("");
  const [focusedField, setFocusedField] = useState("");
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [stageValue, setStageValue] = useState("");
  const [stageError, setStageError] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  useEffect(() => {
    if (selectedItemValue !== null) {
      setStageValue(selectedItemValue?.stage || "");
      setStatusValue(selectedItemValue?.status || false);
    }
  }, [selectedItemValue]);

  const handleStatusChange = (selectedItem) => {
    setStatusValue(selectedItem);
  };

  const handleDataSubmit = () => {
    // Reset all previous errors
    setStageError("");
    setStatusError("");

    let isValid = true;
    if (!stageValue) {
      setStageError("Stage is required");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedItemValue === null) {
          const data = {
            wareHouse: { id: warehouseId },
            stage: stageValue,
          };
          createWarehouseProcessStage(warehouseId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }
                  setStageValue("");
                  setStatusValue("");
                  setStageError("");
                  setStatusError("");
                  setIsSubmitButtonPressed(false);
                  sendDataToWarehouseStageModal({
                    success: true,
                  });
                  setWarehouseStageModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            id: selectedItemValue.id,
            wareHouse: { id: warehouseId },
            stage: stageValue,
            status: statusValue,
          };
          putWarehouseProcessStage(warehouseId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setStageValue("");

                  setStatusValue("");

                  setStageError("");

                  setStatusError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToWarehouseStageModal({
                    success: true,
                  });
                  setWarehouseStageModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };
  const handleModalClose = () => {
    setStageError("");
    setStatusError("");

    setStageValue("");
    setStatusValue("");

    setIsSubmitButtonPressed(false);
    setWarehouseStageModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={warehouseStageModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!warehouseStageModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                Stage {selectedItemValue === null ? "Create" : "Edit"}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className=" mb-2">
              <div className="mx-4">
                <div className=" mt-4 flex-1">
                  <FloatLabel>
                    <InputText
                      id="stageValue"
                      value={stageValue}
                      onChange={(e) => {
                        setStageValue(e.target.value);

                        setStageError("");
                      }}
                      className="w-full text-xl p-2 border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    />
                    {stageError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {stageError}
                      </p>
                    )}

                    <label
                      htmlFor="stageValue"
                      className="text-lg"
                      style={{ color: "blue" }}
                    >
                      Stage <span style={{ color: "red" }}>*</span>
                    </label>
                  </FloatLabel>
                </div>
                {selectedItemValue !== null && (
                  <div className="mt-4">
                  <Dropdown
                    value={statusValue}
                    onChange={(e) => handleStatusChange(e.value)}
                    options={statusItems}
                    optionLabel="name"
                    placeholder="Status"
                    className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                  />
                  </div>
                )}
              </div>
            </div>

            <div className="flex ">
              <Button
                onClick={handleDataSubmit}
                className="mb-3 mx-4 border-round-xl w-full"
                disabled={isSubmitButtonPressed}
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  SUBMIT
                </p>
              </Button>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WarehouseProcessStageCreateModal;
